import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { Doughnut, mixins } from 'vue-chartjs'
import { IChartData } from '@/types'

@Component

export default class DoughnutChart extends Mixins(Doughnut) {

	@Prop()
	private chartData!: IChartData;

	@Prop()
	private chartOptions!: any;

	@Watch('chartData', { immediate: false, deep: true })
	updateChart(next: any, prev: any) {

		if (next.labels != (prev.labels || null)) {

			this.renderChart(this.chartData, this.chartOptions);
		}
	}

	mounted() {
		this.renderChart(this.chartData, this.chartOptions);
	}
}